import { Storage } from "@ionic/storage";

const storage = new Storage({ name: "__user" });
storage.create();

const userDispatch = (data: any) => {
  switch (data.case) {
    case "ADD":
      if (data?.key) {
        storage.set(data.key, data.payload);
      }
      break;
    case "GET":
      if (data?.key) {
        return storage.get(data.key);
      }
      break;
    case "REMOVE":
      if (data?.key) {
        storage.remove(data.key);
      }
      break;
    case "CLEAR":
      storage.clear();
      break;
    default:
      break;
  }
};

export { storage, userDispatch };
